<template>
  <v-dialog
    v-model="dialogScan"
    persistent
    max-width="600px"
    content-class="dialog-content"
  >
    <v-card height="70vh" style="border-radius: 24px">
      <v-card-title class="text-h6"
        >{{ $t("activityQr") }}
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('closeDialogScan')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="height: calc(100% - 62px)">
        <VueQRCodeReader
          v-if="false"
          :camera="camera"
          :isReady="isCameraReady"
          :isLoading="isSetLoadingCamera"
          @onDecode="onDecode"
        />
        <JsQRQRCodeReader
          :isReady="isCameraReady"
          :isLoading="isSetLoadingCamera"
          @onDecode="onDecode"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import VueQRCodeReader from "../qrcode-reader/vueQRCodeReader.vue";
import JsQRQRCodeReader from "../qrcode-reader/jsQRQRCodeReader.vue";
import Axios from "@/config/customer-service";
import { mapState } from "vuex";

export default {
  inject: ["isAppLoading"],
  emits: ["scanText", "closeDialogScan", "onScanSuccess"],
  props: ["dialogScan", "confirmExternal", "refMissionId"],
  components: {
    VueQRCodeReader,
    JsQRQRCodeReader,
  },
  data() {
    return {
      result: "",
      camera: "rear",
      isCameraReady: false,
      isSetLoadingCamera: false,
      inProcess: false,
      missionId: null,
    };
  },

  async mounted() {
    let code = localStorage.getItem("code") || "";
    let mission_id = localStorage.getItem("mission_id") || null;
    if (this.$route.query.code || this.$route.query.codeLuckyDraw) {
      this.result = this.$route.query.code || this.$route.query.codeLuckyDraw;
      this.missionId = this.$route.query.missionId || null;
      await this.onDecode(this.result);
    } else if (code) {
      this.result = code;
      this.missionId = mission_id == "null" ? null : mission_id;
      await this.onDecode(this.result);
    }
    this.isAppLoading(false);
  },

  methods: {
    // ========== ========== Camera ========== ==========
    isUrl(param) {
      if (!param) return false;
      const regex =
        /^(https?:\/\/)?((localhost)|([\da-z.-]+)\.([a-z.]{2,6}))(:\d+)?(\/[\w .-]*)*(\?[\w=&.-]*)?$/i;
      return regex.test(param);
    },
    async onDecode(result) {
      try {
        if (this.inProcess) return;
        this.inProcess = true;
        if (result) {
          var decode;
          var codeLuckyDraw;
          const reward_id = this.getQueryParam(result, "reward_id");
          decode = this.getQueryParam(result, "code");
          codeLuckyDraw = this.getQueryParam(result, "codeLuckyDraw");
          this.result = decode ?? codeLuckyDraw ?? result;
          await this.timeout(500);
          this.pause();

          if (reward_id && this.isUrl(this.result)) {
            let routePath = "";
            try {
              const urlObject = new URL(this.result);
              routePath = urlObject.pathname;
            } catch (error) {
              console.error("Invalid URL:", error);
            }
            if (routePath == "/reward") {
              window.location.href = this.result;
              return;
            }
          }

          if (this.confirmExternal) {
            let code = decode ?? codeLuckyDraw ?? result;
            this.$emit("scanText", code);
            this.unpause();
            this.inProcess = false;
            return;
          }

          if (codeLuckyDraw || this.missionId) {
            this.result = codeLuckyDraw ?? result;
            let mission_id =
              this.getQueryParam(result, "missionId") ??
              this.missionId ??
              this.refMissionId ??
              null;
            const qrcode_mission = await this.getQrCodeMission(
              this.result,
              mission_id
            );
            if (qrcode_mission?.status == "success") {
              const qr_code_res = qrcode_mission.data.mission;
              if (qrcode_mission.data.type == "mission") {
                await this.confirmQRCodeMission(
                  mission_id ?? qr_code_res.id,
                  this.result
                );
              } else {
                await this.getMissionDetail(mission_id ?? qr_code_res.id);
              }
            }
            return;
          }

          // ========== ========== getQrCode ========== ==========
          let check_next = false;
          let error_message = "";
          const qr_code_check_in = await this.getQrCode(this.result, "code");
          if (qr_code_check_in?.status == "success") {
            check_next = false;
            const qr_code_res = qr_code_check_in.data;
            if (
              qr_code_res?.latitude &&
              qr_code_res?.longitude &&
              qr_code_res?.radius
            ) {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                  async (position) => {
                    const location = {
                      latitude: position.coords.latitude,
                      longitude: position.coords.longitude,
                    };
                    await this.confirmQRCode(this.result, [
                      location.latitude,
                      location.longitude,
                    ]);
                  },
                  (error) => {
                    console.error("Error getting location:", error);
                    this.$swal.fire({
                      icon: "error",
                      text: this.$t("locationAccessDenied"),
                      showConfirmButton: false,
                      timer: 5000,
                    });
                    this.unpause();
                  }
                );
              }
            } else if (qr_code_res) {
              await this.confirmQRCode(this.result);
            }
          } else if (qr_code_check_in?.status == "fail") {
            check_next = true;
          }
          // ========== ========== getQrCodeMission ========== ==========
          if (check_next) {
            const qrcode_mission = await this.getQrCodeMission(this.result);
            if (qrcode_mission?.status == "success") {
              check_next = false;
              const qr_code_res = qrcode_mission.data.mission;

              if (qrcode_mission.data.type == "mission") {
                await this.confirmQRCodeMission(qr_code_res.id, this.result);
              } else {
                await this.getMissionDetail(qr_code_res.id);
              }
            } else if (qrcode_mission?.status == "fail") {
              check_next = true;
            }
          }
          // ========== ========== getQrCodeQuestTracking ========== ==========
          if (check_next) {
            let mission_id =
              this.getQueryParam(result, "missionId") ??
              this.missionId ??
              this.refMissionId ??
              null;
            const qr_code_quest_tracking = await this.getQrCodeQuestTracking(
              this.result,
              mission_id
            );
            if (qr_code_quest_tracking?.status == "success") {
              check_next = false;
              const data = qr_code_quest_tracking.data;
              const mission = data.mission;
              const quest_tracking_data = data.quest_tracking_data;
              const condition_special = mission?.condition_special;
              const mode = condition_special?.mode;
              if (mode == "location") {
                if (
                  quest_tracking_data?.latitude &&
                  quest_tracking_data?.longitude &&
                  quest_tracking_data?.radius
                ) {
                  if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                      async (position) => {
                        const location = {
                          latitude: position.coords.latitude,
                          longitude: position.coords.longitude,
                        };
                        await this.confirmQRCodeQuestTracking(this.result, [
                          location.latitude,
                          location.longitude,
                        ]);
                      },
                      (error) => {
                        console.error("Error getting location:", error);
                        this.$swal.fire({
                          icon: "error",
                          text: this.$t("locationAccessDenied"),
                          showConfirmButton: false,
                          timer: 5000,
                        });
                        this.unpause();
                      }
                    );
                  }
                } else {
                  await this.confirmQRCodeQuestTracking(this.result);
                }
              } else {
                await this.confirmQRCodeQuestTracking(this.result);
              }
            } else if (qr_code_quest_tracking?.status == "fail") {
              check_next = true;
              error_message = qr_code_quest_tracking.message;
            }
          }
          if (check_next) {
            this.$swal.fire({
              icon: "error",
              text: error_message,
              showConfirmButton: false,
              timer: 4000,
            });
            this.unpause();
          }
        }
        // ========== ========== ========== ==========
        const url = new URL(window.location.href);
        const code = url.searchParams.get("code");
        const codeLuckyDrawParam = url.searchParams.get("codeLuckyDraw");
        const missionIdParam = url.searchParams.get("missionId");

        if (code) {
          url.searchParams.delete("code");
          window.history.replaceState({}, document.title, url.toString());
        }
        if (codeLuckyDrawParam) {
          url.searchParams.delete("codeLuckyDraw");
          window.history.replaceState({}, document.title, url.toString());
        }
        if (missionIdParam) {
          url.searchParams.delete("missionId");
          window.history.replaceState({}, document.title, url.toString());
        }
      } finally {
        this.inProcess = false;
        localStorage.setItem("code", "");
        localStorage.setItem("mission_id", null);
      }
    },
    unpause() {
      this.isSetLoadingCamera = false;
      this.camera = "rear";
    },
    pause() {
      this.isSetLoadingCamera = true;
      this.camera = "off";
    },
    // ========== ========== ========== ==========

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    async getMyMission(employee_mission_id) {
      let dataReturn = null;
      try {
        const response = await Axios.get("mission/getMyMission", {
          params: {
            employee_mission_id: employee_mission_id,
            view_in_period_remind_date: false,
            view_limit_reached: false,
          },
        });
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          dataReturn = dataResponse.data;
          if (
            dataReturn.not_allowed &&
            dataReturn.employee_mission_id != null
          ) {
            dataReturn = null;
          } else if (dataReturn.not_allowed) {
            dataReturn = null;
          }
        }
      } catch {
        //
      }
      return dataReturn;
    },
    getQrCodeMission(textQr, mission_id = null) {
      return new Promise((resolve) => {
        Axios.get("mission/getQrCodeMission", {
          params: {
            qr_code: textQr,
            mission_id: mission_id,
          },
        })
          .then(({ data }) => {
            const message = data.message || "";
            let response = null;
            if (data.status == "success") {
              response = data.data;
            }
            const dataReturn = {
              status: response ? "success" : "fail",
              message: message,
              data: response,
            };
            resolve(dataReturn);
          })
          .catch((err) => {
            console.log("getQrCodeMission", err);
            const dataReturn = {
              status: "error",
              data: err,
            };
            this.unpause();
            resolve(dataReturn);
          });
      });
    },
    getMissionDetail(mission_id) {
      Axios.get("mission/getMission", {
        params: {
          mission_id: mission_id,
          view_in_period_remind_date: false,
          view_limit_reached: false,
        },
      }).then(({ data }) => {
        let employee_missions_id = data.data.employee_missions_id;
        if (employee_missions_id) {
          this.sendLuckyCode(this.result, employee_missions_id);
        } else {
          this.confirmLuckyCode(mission_id);
        }
      });
    },
    getQueryParam(url, key) {
      const query = url.split("?")[1] || "";
      return (
        query
          .split("&")
          .map((p) => p.split("="))
          .find(([k]) => k === key)?.[1] || null
      );
    },
    getQrCode(textQr) {
      return new Promise((resolve) => {
        Axios.get("mission/getQrCode", {
          params: {
            employee_mission_id: this.$route.params.id,
            qr_code: textQr,
          },
        })
          .then(({ data }) => {
            const message = data.message || "";
            let response = null;
            if (data.status == "success") {
              response = data.data;
            }
            const dataReturn = {
              status: response ? "success" : "fail",
              message: message,
              data: response,
            };
            resolve(dataReturn);
          })
          .catch((err) => {
            console.log("getQRCode", err);
            const dataReturn = {
              status: "error",
              data: err,
            };
            this.unpause();
            resolve(dataReturn);
          });
      });
    },
    getQrCodeQuestTracking(textQr, mission_id = null) {
      return new Promise((resolve) => {
        Axios.get("mission/getQrCodeQuestTracking", {
          params: {
            qr_code: textQr,
            mission_id: mission_id,
          },
        })
          .then(({ data }) => {
            const message = data.message || "";
            let response = null;
            if (data.status == "success") {
              response = data.data;
            }
            const dataReturn = {
              status: response ? "success" : "fail",
              message: message,
              data: response,
            };
            resolve(dataReturn);
          })
          .catch((err) => {
            console.log("getQrCodeQuestTracking", err);
            const dataReturn = {
              status: "error",
              data: err,
            };
            this.unpause();
            resolve(dataReturn);
          });
      });
    },

    // ========== ========== ========== ==========
    confirmQRCode(qr_code, coordinate) {
      return new Promise((resolve) => {
        let body = {
          qr_code: qr_code,
        };
        if (Array.isArray(coordinate) && coordinate.length > 1) {
          body.latitude = coordinate[0];
          body.longitude = coordinate[1];
        }
        Axios.post("mission/scanQrCode", body)
          .then(({ data }) => {
            if (data.status == "success") {
              this.$swal.fire({
                icon: "success",
                html: data.message,
                showConfirmButton: false,
                timer: 4000,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                text: data.message,
                showConfirmButton: false,
                timer: 4000,
              });
            }
          })
          .catch((err) => {
            let message = err.response.data.message || this.$t("error.unknown");
            this.$swal.fire({
              icon: "error",
              text: message,
              showConfirmButton: false,
              timer: 4000,
            });
          })
          .finally(() => {
            this.timeout(3000).then(() => {
              this.unpause();
              resolve(true);
            });
          });
      });
    },
    confirmQRCodeQuestTracking(qr_code, coordinate) {
      return new Promise((resolve) => {
        let body = {
          qr_code: qr_code,
        };
        if (Array.isArray(coordinate) && coordinate.length > 1) {
          body.latitude = coordinate[0];
          body.longitude = coordinate[1];
        }
        Axios.post("mission/confirmMissionQuestTrackingByQr", body)
          .then(({ data }) => {
            if (data.status == "success") {
              this.$swal.fire({
                icon: "success",
                html: data.message,
                showConfirmButton: false,
                timer: 4000,
              });
              this.$emit("onScanSuccess", {
                mission_type: "quest-tracking",
                employee_mission: data.data,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                text: data.message,
                showConfirmButton: false,
                timer: 4000,
              });
            }
          })
          .catch((err) => {
            let message = err.response.data.message || this.$t("error.unknown");
            this.$swal.fire({
              icon: "error",
              text: message,
              showConfirmButton: false,
              timer: 4000,
            });
          })
          .finally(() => {
            this.timeout(3000).then(() => {
              this.unpause();
              resolve(true);
            });
          });
      });
    },
    confirmQRCodeMission(mission_id, qr_code) {
      return new Promise((resolve) => {
        Axios.post("mission/takeMission", {
          mission_id: mission_id,
          qr_code: qr_code,
        })
          .then(async ({ data }) => {
            let checkParamId = null;
            let checkMessage = null;
            if (data.status == "success") {
              checkMessage = this.$t("welcomeActivity");
              checkParamId = data.data.employee_mission_id;
            } else if (data.status == "join") {
              checkParamId = data.data.id;
            } else {
              this.$swal.fire({
                icon: "error",
                text: data.message,
                showConfirmButton: false,
                timer: 4000,
              });
            }
            // ========== ========== ========== ==========
            if (checkParamId) {
              const mission = await this.getMyMission(checkParamId);
              if (mission) {
                this.$router.push({
                  name: "mission-survey",
                  params: { id: checkParamId },
                });
                if (checkMessage) {
                  this.$swal.fire({
                    icon: "success",
                    title: checkMessage,
                    showConfirmButton: false,
                    timer: 4000,
                  });
                }
              } else {
                this.$swal.fire({
                  icon: "error",
                  text: this.$t("errActivity"),
                  showConfirmButton: false,
                  timer: 4000,
                });
              }
            }
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              text: error.response.data.message,
              showConfirmButton: false,
              timer: 4000,
            });
          })
          .finally(() => {
            this.timeout(3000).then(() => {
              this.unpause();
              resolve(true);
            });
          });
      });
    },
    confirmLuckyCode($mission_id) {
      Axios.post("mission/takeMission", {
        mission_id: $mission_id,
      }).then(({ data }) => {
        if (data.status == "success") {
          let employeeMissionId = data.data.employee_mission_id;
          this.sendLuckyCode(this.result, employeeMissionId);
        } else {
          this.$swal.fire({
            icon: "error",
            text: data.message,
            showConfirmButton: false,
            timer: 3000,
          });
        }
      });
    },
    sendLuckyCode(lucky_code, employeeMissionId) {
      Axios.post(
        "/mission/confirmMissionLuckyDraw",
        {
          code: [lucky_code],
          employee_mission_id: employeeMissionId,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
        .then((res) => {
          let code = res.data.data[0];
          if (code.status == "สำเร็จ") {
            this.$swal.fire({
              icon: "success",
              html: `${this.$t("yourCodeIs")} <b>${code.code}</b> (${this.$t(
                "status"
              )}: ${code.status}) </br> ${this.$t("receiveCoin")} ${
                code.point
              } ${this.$t("coin")} `,
              showConfirmButton: true,
              confirmButtonText: this.$t("confirm"),
              confirmButtonColor: this.site.color,
            });
          } else {
            this.$swal.fire({
              icon: "warning",
              html: `${this.$t("yourCodeIs")} <b>${code.code}</b> (${this.$t(
                "status"
              )}: ${code.status}) </br> ${this.$t("checkSendCodeHistory")}`,
              showConfirmButton: true,
              confirmButtonText: this.$t("confirm"),
              confirmButtonColor: this.site.color,
            });
          }
        })
        .catch((error) => {
          console.log("sendLuckyCode error :", error);
        })
        .finally(() => {
          this.unpause();
        });
    },
    // ========== ========== ========== ==========
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  filters: {},
  watch: {
    dialogScan: {
      handler() {
        if (!this.dialogScan) {
          this.isCameraReady = false;
        } else {
          this.isCameraReady = true;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.dialog-content {
  border-radius: 24px !important;
}
</style>
